import { useGet } from './useFetch'
import { useAuth } from './useAuth'

// 播放記錄結構（來自 ad_play_record 表）
export interface AdPlayDetailRecord {
  ad_play_record_id: number
  ad_id: number
  broadcast_device_id: number
  played_at: string // ISO 8601 格式
  is_active: boolean
  advertisement: {
    advertisement_id: number
    title?: string
    supplier_id: number
    supplier?: {
      supplier_id: number
      supplier_name: string
    }
  }
  broadcast_device: {
    broadcast_device_id: number
    name: string
    clinic?: {
      clinic_id: number
      clinic_name: string
      alias?: string | null
    }
  }
}

interface UseAdPlayDetailRecordsResponse {
  success: boolean
  data: {
    items: AdPlayDetailRecord[]
    total: number
    page: number
    pageSize: number
    totalPages: number
  }
}

export interface UseAdPlayDetailRecordsParams {
  supplierId?: number
  adId?: number
  broadcastDeviceId?: number
  clinicId?: number
  startDate?: string // YYYY-MM-DD
  endDate?: string // YYYY-MM-DD
  page?: number
  pageSize?: number
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
}

/**
 * Hook to fetch detailed ad play records (每一筆播放記錄)
 * 使用 /api/ad-play/records 端點
 */
export function useAdPlayDetailRecords(params: UseAdPlayDetailRecordsParams) {
  const { token } = useAuth()
  const {
    supplierId,
    adId,
    broadcastDeviceId,
    clinicId,
    startDate,
    endDate,
    page = 1,
    pageSize = 20,
    sortBy = 'played_at',
    sortOrder = 'desc',
  } = params

  const url = token ? '/api/ad-play/records' : null

  const queryParams: Record<string, unknown> = {
    page,
    pageSize,
    sortBy,
    sortOrder,
  }

  if (supplierId !== undefined) queryParams.supplierId = supplierId
  if (adId !== undefined) queryParams.adId = adId
  if (broadcastDeviceId !== undefined) queryParams.broadcastDeviceId = broadcastDeviceId
  if (clinicId !== undefined) queryParams.clinicId = clinicId
  if (startDate) queryParams.startDate = startDate
  if (endDate) queryParams.endDate = endDate

  const { data, error, mutate } = useGet<UseAdPlayDetailRecordsResponse>(
    url,
    queryParams,
    token ?? null,
  )

  return {
    records: data?.data.items ?? [],
    pagination: data?.data
      ? {
          total: data.data.total,
          page: data.data.page,
          pageSize: data.data.pageSize,
          totalPages: data.data.totalPages,
        }
      : null,
    isLoading: !error && !data,
    isError: !!error,
    mutate,
  }
}
